import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import _axios from "../axios";
import buildLink, { path } from "../urls";
import { AccountContext } from "../contexts/AccountContext";
import { useWindowDimensions } from "./TopHeader";
import { FaAngleDown, FaCaretDown, FaSortUp } from "react-icons/fa";
import { FiList } from "react-icons/fi";
import PointsLoader from "./PointsLoader";
import Slider from "react-slick";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import DOMPurify from "dompurify";
import Cookies from "js-cookie";
import SingleProductForAllCategories from "./SingleProductForAllCategories";
import { HiChevronRight } from "react-icons/hi";

function DesktopMenu(props) {
  const { header_categories } = props;
  const { width } = useWindowDimensions();
  const [accountstate, dispatch] = useContext(AccountContext);
  const [allCategories, setAllCategories] = useState([]);
  const [menuCategories2, setMenuCategories2] = useState([]);
  const [selectedTopCategory, setSelectedTopCategory] = useState({});
  const [viewSubAllCategories2, setViewSubAllCategories2] = useState(false);
  const [overlay, setOverlay] = useState(true);
  const [viewMenuCategories2, setViewMenuCategories2] = useState(true);
  const [selectedMenuCategory2, setSelectedMenuCategory2] = useState();
  const [headerSettings, setHeaderSettings] = useState([]);
  const [local, setLocal] = useState(false);
  const location = useLocation().pathname;
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [topSelling, setTopSelling] = useState([]);
  const [loadingLatest, setLoadingLatest] = useState(false);
  const [categoryLatest, setCategoryLatest] = useState([]);
  const [hover, setHover] = useState(false);
  const types = {
    1: "product",
    2: "category",
    3: "manufacturer",
    4: "seller",
  };

  const settings = {
    slidesPerRow: 3,
    rows: 2,
    infinite: false,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesPerRow: 1,
          rows: 2,
        },
      },
    ],
    arrows: true,
    prevArrow: <CustomPrevArrows direction={"l"} />,
    nextArrow: <CustomNextArrows direction={"r"} />,
  };

  useEffect(() => {
    setViewSubAllCategories2(false);
  }, [location]);

  const [clearHover, setClearHover] = useState(false);

  function CustomPrevArrows({ direction, onClick, style, className }) {
    return (
      <div
        style={{ ...style, padding: "2px 5px" }}
        onClick={onClick}
        className="mySwiper sliderCategories "
      >
        <div className="swiper-button-prev flex justify-center items-center cursor-pointer">
          <BsChevronLeft className="text-dblack" />
        </div>
      </div>
    );
  }

  function CustomNextArrows({ direction, onClick, style, className }) {
    return (
      <div
        style={{ ...style, padding: "2px 15px" }}
        onClick={onClick}
        className="mySwiper sliderCategories"
      >
        <div className=" swiper-button-next flex justify-center items-center cursor-pointer">
          <BsChevronRight className="text-dblack" />
        </div>
      </div>
    );
  }

  function sanitizeHTML(html) {
    if (typeof window !== "undefined") {
      return DOMPurify.sanitize(html);
    } else {
      return html;
    }
  }

  async function getTopSelling(category) {
    if (
      (window.location.host === "www.ishtari.com" ||
        window.location.host === "next.ishtari.com" ||
        window.location.host === "localhost:3000" ||
        window.location.host === "next.ishtari.com.gh" ||
        window.location.host === "ishtari.com.gh" ||
        window.location.host === "ishtari-mobile.com" ||
        Cookies.get("site-local-name") === "ishtari") &&
      window.innerWidth > 1024 &&
      category &&
      viewSubAllCategories2 &&
      typeof category !== "undefined"
    ) {
      setHover(false);
      setLoading(true);
      if (category) {
        var myObject = localStorage.getItem("topSelling-" + category);
        const myObjectParse = JSON.parse(myObject);
        if (
          category &&
          (myObjectParse == null ||
            myObjectParse == undefined ||
            myObjectParse == [])
        ) {
          await _axios
            .get(
              buildLink(
                "getAllTopSellingbyCategoryid",
                undefined,
                window.innerWidth
              ) +
                "&category_id=" +
                category +
                "&limit=20"
            )
            .then((response) => {
              if (
                typeof response.data.data?.products !== "undefined" &&
                response.data.data.products.length > 0
              ) {
                setTopSelling(response.data.data.products);

                localStorage.setItem(
                  "topSelling-" + category,
                  JSON.stringify(response.data.data.products)
                );
              } else {
                localStorage.setItem(
                  "topSelling-" + category,
                  JSON.stringify([])
                );
                setTopSelling([]);
              }
              setLoading(false);
            });
        } else {
          setTopSelling(myObjectParse);
          setLoading(false);
        }
      }
    }
  }
  useEffect(() => {
    if (selectedTopCategory) {
      getTopSelling(selectedTopCategory.category_id);
    }
  }, [selectedTopCategory, viewMenuCategories2, viewSubAllCategories2]);

  useEffect(() => {
    if (selectedTopCategory) {
      getCategoryLatest(selectedTopCategory.category_id);
    }
  }, [selectedTopCategory, viewMenuCategories2, viewSubAllCategories2]);

  const getCategoryLatest = (category_id) => {
    if (
      window.innerWidth > 1024 &&
      category_id &&
      viewSubAllCategories2 &&
      typeof category_id !== "undefined"
    ) {
      var myObject = localStorage.getItem(
        "latestTopSelling-" + selectedTopCategory.category_id
      );
      if (myObject && myObject?.length > 0) {
        setCategoryLatest(JSON.parse(myObject));
      } else {
        setLoadingLatest(true);
        _axios
          .get(
            buildLink("dynamicproducts", undefined, undefined) +
              "latest&category_id=" +
              category_id
          )
          .then((response) => {
            // console.log(response);
            if (response.data.success) {
              if (response.data.data) {
                setCategoryLatest(response.data.data.products);

                localStorage.setItem(
                  "latestTopSelling-" + selectedTopCategory.category_id,
                  JSON.stringify(response.data.data.products)
                );
              }
            }
            setLoadingLatest(false);
          });
      }
    }
  };

  useEffect(() => {
    // if (header_categories ) {
    setMenuCategories2(header_categories);
    dispatch({ type: "setCategoriesFavoriteList", payload: header_categories });

    // setSelectedMenuCategory2(header_categories[0]);
    // } else {

    //   axiosServer
    //     .get(
    //       buildLink("headerv2", undefined, undefined, window.config["site-url"])
    //     )
    //     .then((response) => {
    //       const data = response?.data;

    //       setMenuCategories2(data.data);
    //       // setSelectedMenuCategory2(data[0]);
    //     });
    // }
    //sub menu categories
    // if (window.innerWidth > 1024) {

    // }
    return () => {};
    //
  }, [header_categories]);

  useEffect(() => {
    if (viewSubAllCategories2) {
      _axios
        .get(
          buildLink(
            "all_categories",
            undefined,
            undefined,
            window.config["site-url"]
          )
        )
        .then((response) => {
          try {
            const data = response.data.data;
            setAllCategories(data);
            setSelectedTopCategory(data[0]);
            dispatch({ type: "setCategoriesFavoriteList", payload: data });
            // setTemp(data[0])
          } catch (error) {}
        });
    }
  }, [viewSubAllCategories2]);

  useEffect(() => {
    if (window.location.host === "localhost:3000") {
      setLocal(true);
    }
    if (width > 650) {
      _axios
        .get(buildLink("all_categories", undefined, window.innerWidth))
        .then((response) => {
          try {
            const data = response.data.data;
            setAllCategories(data);
            setSelectedTopCategory(data[0]);
          } catch (error) {}
        });
      _axios
        .get(buildLink("headerv2", undefined, window.innerWidth))
        .then((response) => {
          const data = response?.data;
          setMenuCategories2(data.data);
          setSelectedMenuCategory2(data[0]);
          setHeaderSettings(data.header_settings);
        });
    }
  }, []);

  /* ON CLICK ESC CLOSE OVERLAY */
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      setOverlay(false);
      setViewMenuCategories2(false);
      setViewSubAllCategories2(false);
    }
  });

  /* ON LINK CHANGE CLOSE OVERLAY */
  useEffect(() => {
    setOverlay(false);
    setViewMenuCategories2(false);
  }, [location]);

  function useTimeout(callback, delay) {
    const timeoutRef = React.useRef(null);
    const savedCallback = React.useRef(callback);
    React.useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
    React.useEffect(() => {
      const tick = () => savedCallback.current();
      if (typeof delay === "number") {
        timeoutRef.current = window.setTimeout(tick, delay);
        return () => window.clearTimeout(timeoutRef.current);
      }
    }, [delay]);
    return timeoutRef;
  }

  useTimeout(
    () => {
      if (selectedMenuCategory2) {
        setOverlay(true);
        setViewMenuCategories2(true);
      }
    },
    clearHover ? null : 100
  );
  function refresh(test) {
    // alert(test);
    // alert(window.location.pathname)
    if (test === window.location.pathname) {
      window.location.reload();
    } else {
      history(test);
    }
  }
  return (
    <div
      className="hidden relative xl:block lg:block w-screen bg-dgrey1 bg-opacity-5"
      onClick={() => {
        setOverlay(false);
        setClearHover(true);
        setViewMenuCategories2(false);
        // setViewSubAllCategories2(false);
      }}
      onMouseLeave={() => {
        setOverlay(false);
        setClearHover(true);
        setViewSubAllCategories2(false);
        setViewMenuCategories2(false);
      }}
    >
      {/* CATEGORY BUTTONS */}
      <div
        className={`${
          window.config["showMenu"] ? "block" : "hidden"
        }  px-6 mx-auto flex items-center text-dblack`}
      >
        <div
          onMouseEnter={() => {
            setOverlay(true);
            setViewSubAllCategories2(true);
            setViewMenuCategories2(false);
          }}
          className="flex items-center border-r gap-3 px-4 text-dblackk  font-[900] text-md border-dplaceHolder hover:text-dbase cursor-pointer "
          style={{
            borderRight: "1px solid rgb(226, 229, 241)",
            lineHeight: "19.6px",
          }}
        >
          <FiList />
          <div>All Categories</div>
          <FaAngleDown
            className={` text-sm transition-all  ${
              viewSubAllCategories2
                ? "rotate-180 text-dbase"
                : "rotate-0 text-dblack"
            } `}
          />
        </div>

        {/* Menu  categories */}
        {window.config["showMenu2"] && (
          <div className="flex">
            {menuCategories2?.length > 1 &&
              menuCategories2?.map((category) => (
                <div
                  key={Math.random()}
                  className={`cursor-pointer px-4 items-center menu-hover flex`}
                  onMouseEnter={() => {
                    setClearHover(false);
                    setViewSubAllCategories2(false);
                    setSelectedMenuCategory2(category);
                  }}
                  onMouseLeave={() => {
                    setClearHover(true);
                  }}
                  style={{ lineHeight: "19.6px" }}
                >
                  {/* {accountstate.admin ? (
                    <Link
                      to={`${path}/category/${category["title"].mobile_type_id}`}
                      dangerouslySetInnerHTML={{
                        __html: category["title"].title,
                      }}
                    ></Link>
                  ) : ( */}
                  <Link
                    className="text-d15"
                    onClick={() =>
                      refresh(
                        `${path}/${category["title"].title
                          .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                          .replace(/\s+/g, "-")
                          .replace(/'/g, "")}/c=${
                          category["title"].mobile_type_id
                        }`
                      )
                    }
                    to={{
                      pathname: `${path}/${category["title"].title
                        .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                        .replace(/\s+/g, "-")
                        .replace(/'/g, "")}/c=${
                        category["title"].mobile_type_id
                      }`,
                      state: {
                        banner_image_id: "",
                        source_type: "default",
                        source_type_id: "",
                      },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: category["title"].title,
                    }}
                  ></Link>
                  <FaCaretDown
                    className={`${
                      viewMenuCategories2 && selectedMenuCategory2 == category
                        ? "text-dbase rotate-180"
                        : "text-dblack rotate-0"
                    } h-full my-auto  transition-all mx-3 text-d10 `}
                  />
                  {/* )} */}
                </div>
              ))}
            {/* <Link
              to= {{ pathname:`${path}/latest`,state:{
                banner_image_id: "",
                source_type: "default",
                source_type_id: "",
              }}}
            
              className="cursor-pointer px-4 items-center flex menu-hover text-d14"
              style={{ minHeight: "48px", lineHeight: "19.6px" }}
            >
              New Arrivals
            </Link> */}

            {headerSettings.length > 0 &&
              headerSettings.map((setting, index) => (
                <div
                  key={index}
                  className={`px-4 hover:text-dbase text-dblack cursor-pointer items-center flex menu-hover text-d14 h-12${
                    index !== headerSettings.length - 1 ? "" : ""
                  } ${!setting.value ? "hidden" : ""}`}
                >
                  <Link
                    to={`/${
                      setting.key === "new_arrivals"
                        ? "new-arrivals/c=1246"
                        : setting.key === "back_to_stock"
                        ? "back-to-stock/c=1247"
                        : "top-selling/c=1386"
                    }`}
                  >
                    {setting.title}
                  </Link>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* Overlay */}
      {overlay && (
        <div
          onMouseEnter={() => {
            setClearHover(true);
            setOverlay(false);
            setViewSubAllCategories2(false);
            setViewMenuCategories2(false);
          }}
          className=" relative px-5"
          style={
            {
              // zIndex: "20",
              // top: accountstate.admin ? "10rem" : "7rem",
              // height: "800%",
            }
          }
        ></div>
      )}

      {/* All Category menu  */}
      {/* {viewSubAllCategories2 && ( */}
      {/* <div className={`  transition-all  `}> */}
      {viewSubAllCategories2 && (
        <div
          onMouseEnter={() => {
            setViewSubAllCategories2(false);
          }}
          className={` inset-0 fixed w-screen h-screen bg-dblackOverlay z-20 ${
            accountstate.admin ? " top-40" : "top-28"
          } `}
        >
          {" "}
        </div>
      )}
      <div
        className={`absolute overflow-hidden duration-800 ease-in-out left-5 transition-all ${
          viewSubAllCategories2
            ? "h-fit top-10 z-40 opacity-100"
            : "h-0 top-20 opacity-0 -z-40"
        }`}
      >
        <div className=" relative ">
          <div className=" ml-36 text-white translate-y-3">
            <FaSortUp className="text-xl text-dsearchGrey" />
          </div>
          <div className="flex w-full bg-white rounded-md relative overflow-auto ">
            

            <div className="relative">
              <div className="ml-36 text-white translate-y-3">
                <FaSortUp className="text-xl text-dsearchGrey" />
              </div>
              <div className="flex w-full bg-white rounded-md relative overflow-auto">
                <div className="bg-dsearchGrey py-3 max-h-[600px] overflow-auto hide-scrollbar show-scrollbar">
                  {allCategories?.map((category) => (
                    <p
                      key={category.category_id}
                      onMouseEnter={() => setSelectedTopCategory(category)}
                    >
                      <Link
                        to={{
                          pathname: accountstate.admin
                            ? `${path}/category/${category.category_id}`
                            : `${path}/${category.name
                                .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                .replace(/\s+/g, "-")
                                .replace(/'/g, "")}/c=${category.category_id}`,
                          state: {
                            banner_image_id: "",
                            source_type: "categories",
                            source_type_id: "",
                          },
                        }}
                        className="flex justify-between items-center py-1 hover:text-dblue px-4"
                      >
                       <div className="flex items-center gap-2 justify-center ">
                       <LazyLoadImage
                          alt={category.name}
                          src={category.image}
                          width={40}
                          height={40}
                          placeholderSrc="https://ishtari.com/static/product_placeholder_square.png"
                        />
                        <span
                          className="font-light text-d13"
                          dangerouslySetInnerHTML={{ __html: category.name }}
                        ></span>
                       </div>

                          {category.tag_image === "" ? null : (
                            <img
                              alt={category.name}
                              src={category.tag_image}
                              width={35}
                              height={16}
                              loading="lazy"
                              className="ml-8 "
                            />
                          )}

                          <span className="ml-3">
                            <HiChevronRight />
                          </span>
                      </Link>
                    </p>
                  ))}
                </div>

                {/* Second Scrollable Container */}
                <div
                  className="bg-dgreyPrev px-4 overflow-y-auto"
                  style={{ width: "300px", maxHeight: "600px" }}
                >
                  <div className="flex items-center justify-between py-5 border-b border-dinputBorder mb-2">
                    <h2
                      className="font-semibold"
                      dangerouslySetInnerHTML={{
                        __html: selectedTopCategory?.name,
                      }}
                    ></h2>
                    <Link
                      className="text-dblue text-sm"
                      to={`${path}/category/${selectedTopCategory?.category_id}`}
                    >
                      <span>View All</span>
                      <i className="icon icon-angle-right"></i>
                    </Link>
                  </div>

                  {selectedTopCategory?.categories &&
                    selectedTopCategory["categories"]?.map((sub_category) => (
                      <Link
                        key={sub_category.category_id}
                        to={`${path}/category/${sub_category.category_id}`}
                        state={{
                          banner_image_id: "",
                          source_type: "categories",
                          source_type_id: "",
                        }}
                        className="flex items-center py-1 hover:bg-dgrey"
                      >
                        <LazyLoadImage
                          alt={sub_category.name}
                          src={sub_category.image}
                          width={35}
                          height={35}
                          placeholderSrc="https://ishtari.com/static/product_placeholder_square.png"
                        />
                        <span
                          className="ml-3 font-light text-xs"
                          dangerouslySetInnerHTML={{
                            __html: sub_category.name,
                          }}
                        ></span>
                      </Link>
                    ))}
                </div>

                {/* Third Scrollable Section */}
                <div className="w-[600px] px-5 bg-dgrey py-3 relative overflow-x-hidden overflow-y-auto hide-scrollbar show-scrollbar transition-all bg-dsearchGrey max-h-[600px] h-full">
                  <div>
                    <div className="flex items-center mt-4 text-dblack">
                      <Link
                        to={{
                          pathname: "/top-selling/c=1386",
                          query: {
                            category_id: selectedTopCategory?.category_id,
                          },
                        }}
                        className="pr-semibold cursor-pointer hover:text-dblue"
                      >
                        Explore Top Selling Products
                      </Link>
                      <i className="icon icon-angle-right"></i>
                    </div>
                    {loading ? (
                      <PointsLoader />
                    ) : (
                      topSelling.length > 0 && (
                        <div className="w-full cursor-pointer ">
                          <Slider {...settings}>
                            {topSelling?.slice(0, 10).map((item) => (
                              <div key={item.product_id}>
                                <SingleProductForAllCategories
                                  item={item}
                                  topSelling={true}
                                  carousel={true}
                                />
                              </div>
                            ))}
                            {topSelling?.slice(10).map((item) => (
                              <div key={item.product_id}>
                                <SingleProductForAllCategories
                                  item={item}
                                  topSelling={true}
                                  carousel={true}
                                />
                              </div>
                            ))}
                          </Slider>
                        </div>
                      )
                    )}
                    <div className="cursor-pointer">
                      <div className="flex items-center mt-4 text-dblack pb-4">
                        <h2 className="pr-semibold">
                          Explore{" "}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: sanitizeHTML(selectedTopCategory?.name),
                            }}
                          ></span>{" "}
                          Latest Products
                        </h2>
                      </div>
                      {loadingLatest ? (
                        <PointsLoader />
                      ) : (
                        categoryLatest.length > 0 && (
                          <div className="w-full cursor-pointer">
                            <Slider {...settings}>
                              {categoryLatest?.slice(0, 10).map((item) => (
                                <div key={item.product_id}>
                                  <SingleProductForAllCategories
                                    item={item}
                                    topSelling={true}
                                    carousel={true}
                                  />
                                </div>
                              ))}
                              {categoryLatest?.slice(10).map((item) => (
                                <div key={item.product_id}>
                                  <SingleProductForAllCategories
                                    item={item}
                                    topSelling={true}
                                    carousel={true}
                                  />
                                </div>
                              ))}
                            </Slider>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div>)    */}
      {/* </div> */}

      {/* Menu Categories */}
      <div
        className={`absolute bg-white transition-all duration-300 w-screen ${
          viewMenuCategories2 && selectedMenuCategory2
            ? " top-12 z-50 opacity-100"
            : " top-24  opacity-0"
        } 
        `}
        // style={{ top: accountstate?.admin ? "10rem" : "7rem" }}
      >
        {viewMenuCategories2 && selectedMenuCategory2 && (
          <div
            className=" h-full "
            onMouseLeave={() => {
              setViewSubAllCategories2(false);
              setViewMenuCategories2(false);
            }}
            style={{ borderTop: "1px solid rgb(226, 229, 241)" }}
          >
            <div className="">
              <div className="bg-white ">
                <div className="bg-white  flex  py-6  px-10">
                  {/* Categories */}
                  <div
                    // style={{width:'15%'}}
                    className={`pl-4 w-2/12`}
                  >
                    <Link
                      to={
                        {
                          pathname: `${path}/${selectedMenuCategory2[
                            "top-category"
                          ].name
                            ?.replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                            ?.replace(/\s+/g, "-")}/c=${
                            selectedMenuCategory2["top-category"].category_id
                          }`,
                          state: {
                            banner_image_id: "",
                            source_type: "categories",
                            source_type_id: "",
                          },
                        }
                        // accountstate?.admin
                        //   ? `${path}/category/${selectedMenuCategory2["top-category"].category_id}`
                        //   :
                      }
                      className="font-semibold mb-4"
                      dangerouslySetInnerHTML={{
                        __html:
                          selectedMenuCategory2[
                            "top-category"
                          ].name?.toUpperCase(),
                      }}
                    />
                    {selectedMenuCategory2["sub-categories"]?.map(
                      (category) => (
                        <Link
                          key={Math.random()}
                          className="block text-sm py-2 hover:text-dblue "
                          dangerouslySetInnerHTML={{ __html: category.name }}
                          to={
                            {
                              pathname: `${path}/${category.name
                                .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                .replace(/\s+/g, "-")}/c=${
                                category.category_id
                              }`,
                              state: {
                                banner_image_id: "",
                                source_type: "categories",
                                source_type_id: "",
                              },
                            }
                            // accountstate.admin
                            //   ? `${path}/category/${category.category_id}`
                            //   :
                          }
                        />
                      )
                    )}
                  </div>
                  {/* Brands */}
                  <div className={`flex space-x-1 w-${10}/12`}>
                    {selectedMenuCategory2["partitions"]?.map((ban) => (
                      <div className={` p-0`}>
                        {ban?.banners?.map((banner) => (
                          <div
                            className={`w-${banner.size}/12 cursor-pointer`}
                            key={Math.random()}
                            onClick={() =>
                              history(
                                // accountstate.admin

                                //   ? `${path}/${types[banner.mobile_type]}/${
                                //       banner.mobile_type_id
                                //     }`
                                //   :
                                `${path}/${banner.name
                                  .replace(/\s+&amp;\s+|\s+&gt;\s+/g, "-")
                                  .replaceAll("%", "")
                                  .replace(/\s+/g, "-")}/${types[
                                  banner.mobile_type
                                ].slice(0, 1)}=${banner.mobile_type_id}`,
                                {
                                  state: {
                                    banner_image_id: "",
                                    source_type: "categories",
                                    source_type_id: "",
                                  },
                                }
                              )
                            }
                          >
                            <img
                              className={``}
                              src={banner.image_url}
                              alt={banner.image.name}
                              title={banner.image.name}
                            />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DesktopMenu;
